import {ActionReducer, ActionReducerMap, combineReducers, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromInvoice from './invoice.reducer';


export interface InvoicesState {
  invoices: fromInvoice.InvoiceState;
}

export const reducers: ActionReducerMap<InvoicesState> = {
  invoices: fromInvoice.reducer,
};

export const reducer: ActionReducer<InvoicesState> = combineReducers(reducers);

export const getManagerState = createFeatureSelector<InvoicesState>('invoicesFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/store/reducers/index.ts